import { useCallback, useEffect, useState } from 'react';
import {
  List,
  useList,
  ListContextProvider,
  TextField,
  Datagrid,
  useGetRecordId,
  DateField,
} from 'react-admin';

import { companiesDataProvider } from '@/dataProvider';
import { ICompanyCohortItemResponseParams } from '@/types';

interface ICompanyCohortsListProps {}

function CompanyCohortsList({}: ICompanyCohortsListProps): JSX.Element {
  const [cohortsList, setCohortsList] = useState<ICompanyCohortItemResponseParams[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const companyId = useGetRecordId();

  const getCohortsListByCompany = useCallback(() => {
    companiesDataProvider.getCohortsList(companyId).then(data => {
      setCohortsList(data);
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    getCohortsListByCompany();
  }, []);

  const listContext = useList({ data: cohortsList, isLoading });

  return (
    <List actions={false} pagination={false}>
      <ListContextProvider value={listContext}>
        <Datagrid bulkActionButtons={false}>
          <TextField source="name" label="resources.cohorts.name" sortable={false} />
          <TextField source="description" label="resources.cohorts.description" sortable={false} />
          <DateField source="createdAt" label="resources.cohorts.created_at" sortable={false} />
          <DateField source="updatedAt" label="resources.cohorts.updated_at" sortable={false} />
          <TextField
            source="employeeCount"
            label="resources.cohorts.employees_count"
            sortable={false}
          />
          <TextField
            source="withdrawal_limit"
            label="resources.company.form.add_company.withdrawal_limit"
            sortable={false}
          />
          <TextField
            source="number_of_transactions"
            label="resources.company.form.add_company.number_of_transactions"
            sortable={false}
          />
          <TextField
            source="min_amount"
            label="resources.company.form.add_company.min_amount"
            sortable={false}
          />
          <TextField
            source="max_amount"
            label="resources.company.form.add_company.max_amount"
            sortable={false}
          />
        </Datagrid>
      </ListContextProvider>
    </List>
  );
}

export default CompanyCohortsList;
